import React from 'react';

import { DashboardContainer } from '../index.style';
import {
  MapShell,
  MapSkeleton,
  PillRow,
  SkeletonBlock,
  TabsRow,
  ListCard,
} from './DashboardSkeleton.style';

const DashboardSkeleton: React.FC = () => {
  const skeletonRowKeys = [
    'skeleton-row-1',
    'skeleton-row-2',
    'skeleton-row-3',
    'skeleton-row-4',
    'skeleton-row-5',
    'skeleton-row-6',
    'skeleton-row-7',
    'skeleton-row-8',
  ];

  return (
    <DashboardContainer data-testid='dashboard-skeleton'>
      <div className='portfolio-tabs'>
        <TabsRow>
          <SkeletonBlock width='120px' height='40px' radius='10px' />
          <SkeletonBlock width='120px' height='40px' radius='10px' />
          <SkeletonBlock width='100px' height='40px' radius='10px' />
          <div style={{ marginLeft: 'auto' }}>
            <SkeletonBlock width='140px' height='40px' radius='10px' />
          </div>
        </TabsRow>
      </div>

      <div className='dashboard-content'>
        <ListCard>
          <SkeletonBlock width='60%' height='18px' />
          {skeletonRowKeys.map((key) => (
            <PillRow key={key}>
              <SkeletonBlock width='56px' height='14px' radius='7px' />
              <SkeletonBlock height='16px' />
            </PillRow>
          ))}
        </ListCard>

        <MapShell>
          <MapSkeleton />
        </MapShell>
      </div>
    </DashboardContainer>
  );
};

export default DashboardSkeleton;
